import blank from "@/components/blank.vue"
import placeHolder from "@/components/placeholder.vue"
import index from "@/view/index.vue"
import login from "@/view/other/page-login.vue"  // 临时登录页
import noPermission from "@/view/other/page-noPermission.vue"  // 无权限页
import error from "@/view/other/page-error.vue"  // 404页

// 首页
import dashBoard from "@/view/page-dashboard.vue"  // 用户列表

// 用户管理
import userList from "@/view/user-manage/page-userList.vue"  // 工号列表
// 会员管理
import memberList from "@/view/member-manage/page-memberList.vue"  // 会员列表
// 数据分析
import dataProduct from "@/view/data-manage/page-dataProduct.vue"  // 产品查看
import dataOrder from "@/view/data-manage/page-dataOrder.vue"  // 订单查看
import customerAnalysis from "@/view/data-manage/page-CustomerAnalysis.vue"  // 订单查看
// 提成管理
import managerList from "@/view/royalty-manage/page-manager.vue"  // 客户经理
import saleView from "@/view/royalty-manage/page-sale-view.vue"
import agentView from "@/view/royalty-manage/page-agent-view.vue" //代理商提成统计 
import agentRoyaltyManage from "@/view/royalty-manage/page-agent-royalty-manage.vue"//代理商提成管理
import agentManage from "@/view/royalty-manage/page-agent-manage.vue"//代理商提成管理  
import saleManage from "@/view/royalty-manage/page-sale-manage.vue"//代理商提成管理
// 分成管理
import divisionView from "@/view/division-manage/page-divisionView.vue"  // 分成比例查看
import dealer_manage from "@/view/division-manage/page-dealer-manage.vue"  //销售分成管理



import salesSplitManage from "@/view/division-manage/page-sales-split-manage.vue" //销售分成管理
import eiisysView from "@/view/division-manage/page-eiisysView.vue"
import salesSplitView from '@/view/division-manage/page-sales-split-view.vue'//销售分成管理




const model = window.model; // 获取模式
let router = [
    {
        path: '',
        name:"wait",
        redirect:{name:'dashboard'},
        component:blank,
    },
    {
        path: '/404',
        alias: '*',
        name:"error",
        component:error,
    },
    {
        path: '/noPermission',
        name:"noPermission",
        component:noPermission,
    },
    {
        path: '/',
        key:'menu_list',
        component:index,
        children:[
            {
                path: 'dashboard',
                name: 'dashboard',
                component:dashBoard,
            },
            {
                path: 'user-manage',
                name: 'user-manage',
                title:"用户管理",
                component:blank,
                icon:"user.svg",
                meta:{
                    code:1000,
                },
                children:[
                    {
                        path: 'user-list',
                        name: 'user-list',
                        title:"用户列表",
                        component:userList,
                         meta:{
                            code:1001,
                        },
                    },
                ]
            },
            {
                path: 'member-manage',
                name: 'member-manage',
                title:"会员管理",
                component:blank,
                icon:'associator.svg',
                meta:{
                    code:2000,
                },
                children:[
                    {
                        path: 'member-list',
                        name: 'member-list',
                        title:"会员列表",
                        component:memberList,
                        meta:{
                            code:2001,
                        },
                    },
                ]
            },
            {
                path: 'data-manage',
                name: 'data-manage',
                title:"数据分析",
                component:blank,
                icon:'data.svg',
                meta:{
                    code:3000,
                },
                children:[
                    {
                        path: 'product',
                        name: 'data-product',
                        title:"产品查看",
                        component:dataProduct,
                        meta:{
                            code:3001,
                        },
                    },
                    {
                        path: 'order',
                        name: 'data-order',
                        title:"订单查看",
                        component:dataOrder,
                        meta:{
                            code:3002,
                        },
                    },
                    {
                        path: 'analysis',
                        name: 'data-analysis',
                        title:"用户分析",
                        component:customerAnalysis,
                        meta:{
                            code:3003,
                        },
                    },
                ]
            },
            {
                path: 'royalty-manage',
                name: 'royalty-manage',
                title:"提成管理",
                component:blank,
                icon:"royalty.svg",
                meta:{
                    code:4000,
                },
                children:[
                    {
                        path: 'client-manager',
                        name: 'client-manager',
                        title:"客户经理管理",
                        component:managerList,
                        meta:{
                            code:4001,
                        },
                    },
                    {
                        path: 'sale-manage',
                        name: 'sale-manage',
                        title:"客户经理提成管理",
                        component:saleManage,
                        meta:{
                            code:4002,
                        },
                    },
                    {
                        path: 'sale-view',
                        name: 'sale-view',
                        title:"客户经理提成统计",
                        component:saleView,
                        meta:{
                            code:4002,
                        },
                    },
                    {
                        path: 'agent-manage',
                        name: 'agent-manage',
                        title:"代理商管理",
                        component:agentManage,
                        meta:{
                            code:4002,
                        },
                    },
                    {
                        path: 'agent-royalty-manage',
                        name: 'agent-royalty-manage',
                        title:"代理商提成管理",
                        component:agentRoyaltyManage,
                        meta:{
                            code:4002,
                        },
                    },
                    {
                        path: 'agent-view',
                        name: 'agent-view',
                        title:"代理商提成统计",
                        component:agentView,
                        meta:{
                            code:4002,
                        },
                    },
                ]
            },
            {
                path: 'division-manage',
                name: 'division-manage',
                title:"分成管理",
                component:blank,
                icon:"fall-into.svg",
                meta:{
                    code:5000,
                },
                children:[
                    {
                        path: 'dealer-manage',
                        name: 'dealer-manage',
                        title:"经销商管理",
                        component:placeHolder,
                        meta:{
                            code:5001,
                        },
                    },
                    {
                        path: 'division-view',
                        name: 'division-view',
                        title:"经销商分成统计",
                        component:placeHolder,
                        meta:{
                            code:5002,
                        },
                    },
                   {
                        path: 'eiisys-view',
                        name: 'eiisys-view',
                        title:"海翕分成统计",
                        component:eiisysView,
                        meta:{
                            code:5003,
                        },
                    },
                    {
                        path: 'salesSplit-manage',
                        name: 'salesSplit-manage',
                        title:"销售分成管理",
                        component:salesSplitManage,
                        // meta:{
                        //     code:5003,
                        // },
                    },
                    {
                        path: 'salesSplit-view',
                        name: 'salesSplit-view',
                        title:"销售分成统计",
                        component:salesSplitView,
                        // meta:{
                        //     code:5003,
                        // },
                    },
                ]
            },
            {
                path: 'business-manage',
                name: 'business-manage',
                title:"商机管理",
                component:blank,
                icon:"business.svg",
                meta:{
                    code:6000,
                },
                children:[
                    {
                        path: 'business-confirm',
                        name: 'business-confirm',
                        title:"商机确认",
                        component:placeHolder,
                        meta:{
                            code:6001,
                        },
                    },
                ]
            },
            {
                path: 'onCall-manage',
                name: 'onCall-manage',
                title:"随叫随到管理",
                component:blank,
                icon:"on-call.svg",
                meta:{
                    code:7000,
                },
                children:[
                    {
                        path: 'train-bank',
                        name: 'train-bank',
                        title:"培训题库",
                        //component:placeHolder,
                        component:resolve => require(['@/view/oncall-manage/train-bank.vue'],resolve),
                        meta:{
                            code:7001,
                        },
                    },
                    {
                        path: 'onCall-serve',
                        name: 'onCall-serve',
                        title:"随叫随到服务",
                        component:placeHolder,
                        meta:{
                            code:7002,
                        },
                    },
                ]
            },
            {
                path: 'jobNum-manage',
                name: 'jobNum-manage',
                title:"工号管理",
                component:blank,
                icon:"jobnum.svg",
                meta:{
                    code:8000,
                },
                children:[
                    {
                        path: 'jobNum-list',
                        name: 'jobNum-list',
                        title:"工号列表",
                        //component:placeHolder,
                        component:resolve => require(['@/view/jobnum-manage/jobnum-list.vue'],resolve),
                        meta:{
                            code:8001,
                        },
                    }
                ]
            },
            {
                path: 'toolbar-manage',
                name: 'toolbar-manage',
                title:"工具条管理",
                component:blank,
                icon:"jobnum.svg",
                meta:{
                    code:9000,
                },
                children:[
                    {
                        path: 'toolbar-congfig',
                        name: 'toolbar-congfig',
                        title:"快服工具条配置",
                        //component:placeHolder,
                        component:resolve => require(['@/view/toolbar-manage/toolbar-config.vue'],resolve),
                        meta:{
                            code:9001,
                        },
                    }
                ]
            },


        ]

    },
]


// 开发模式 补充个重定向
// let r_wait = router.find(item=>item.name == 'wait');
// if( model != 3 && r_wait){
//     r_wait.redirect = {name:'login'}
// }

if(model == 1 || model == 2){
    router.unshift({
        path: '/login',
        name:"login",
        component:login,
    })
}

export default router;